import { httpClient } from "../http/httpClient";

export type DeleteLeadResponse = {
  success: boolean;
};

export async function deleteLead(id: string) {
  const { data } = await httpClient
    .delete<DeleteLeadResponse>(`/lead/${id}`)
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
